/* istanbul ignore file */
// libs
import React, { ReactElement } from 'react';
import { useParams } from 'react-router-dom';
// components
import { Show } from 'framework/show';
import { ShowPageLayout } from 'framework/ui/layout';
import ShowAccountPageMenu from 'domain/sales/account/Show/ShowAccountPageMenu';
import SingleAccountBreadcrumbs from 'domain/sales/account/shared/SingleAccountBreadcrumbs';
// services
import { useAccountResourceService } from 'domain/shared/account';
import AccountEntityHeader from 'domain/sales/account/shared/AccountEntityHeader';

type ViewAccountProps = {
  children: ReactElement | ReactElement[];
  breadcrumbs?: ReactElement;
  hasEntityHeader?: boolean;
};

const ViewAccount = ({
  children,
  breadcrumbs = <SingleAccountBreadcrumbs />,
  hasEntityHeader = true,
}: ViewAccountProps) => {
  const { id } = useParams<{ id: string }>();
  const { getById } = useAccountResourceService();

  return (
    <Show getDataMethod={() => getById(id!)}>
      <ShowPageLayout
        menu={<ShowAccountPageMenu />}
        breadcrumbs={breadcrumbs}
        entityHeader={hasEntityHeader ? <AccountEntityHeader /> : null}
      >
        {children}
      </ShowPageLayout>
    </Show>
  );
};

export default ViewAccount;
